import { useCopyToClipboard } from '@bettermode/common/hooks'
import { isTouchDevice } from '@bettermode/common/user-agent'
import { Message } from '@tribeplatform/gql-client/types'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useI18n } from '../../../i18n/index.js'

interface Props {
  message: Message
  isCurrentUserMsg: boolean
  onEdit?: () => void
}

export const MessageActions = ({
  message,
  onEdit,
  isCurrentUserMsg,
}: Props) => {
  const { $t } = useI18n()
  const { copied, copyToClipboard } = useCopyToClipboard({
    content: message.content,
  })

  if (isTouchDevice()) {
    return null
  }

  const canEdit = isCurrentUserMsg
  const canCopy = !!message.content && message.content !== '<p></p>'
  const hasAnyAction = canEdit || canCopy

  return (
    <>
      {hasAnyAction && (
        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 h-px border-t border-line-subdued grow" />
      )}
      <div className="flex items-center gap-x-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        {isCurrentUserMsg && (
          <IconButton
            size="sm"
            variant="secondaryNeutral"
            tooltip
            accessibilityLabel={$t({
              defaultMessage: 'Edit',
              id: 'Generics.Edit',
            })}
            onClick={onEdit}
            icon={<SvgIcon name="edit-2" />}
          />
        )}
        {canCopy && (
          <IconButton
            size="sm"
            variant="secondaryNeutral"
            tooltip
            accessibilityLabel={$t({
              defaultMessage: 'Copy',
              id: 'Generics.Copy',
            })}
            icon={<SvgIcon name={copied ? 'check' : 'copy'} />}
            onClick={copyToClipboard}
          />
        )}
      </div>
    </>
  )
}
